import React from "react";
import ReactDOM from "react-dom/client";

import "@/i18n/config";
import App from "./App";
import "./index.css";
// trigger vercel ignore script diagnostics
// verify fixed ignore script path resolution

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
